import React, { useState } from 'react'
import Navbar from '../components/navbar/navbar'
import FooterTop from '../components/footer-top'
import Footer from '../components/footer'
import { contactUs } from '../services/ApiServices'
import toast from 'react-hot-toast'
import validator from 'validator';

export default function Contact() {
    const initialState = {
        name: '',
        email: '',
        subject: '',
        message: ''
    }
    const [contactData, setContactData] = useState<any>(initialState);
    const [isProcessing, setProcessing] = useState<boolean>(false);
    const [isOpenSendMsgModal, setOpenSendMsgModal] = useState<boolean>(false);

    const handleOnChange = (e: any) => {
        setContactData({ ...contactData, [e.target.name]: e.target.value });
    }

    console.log("contactData", contactData);

    const validation = (e: any) => {
        e.preventDefault();
        if (!contactData?.name) {
            toast.error("Please enter your name");
            return;
        }
        if (!contactData?.email) {
            toast.error("Please enter your email");
            return;
        }
        if (contactData?.email && !validator.isEmail(contactData?.email)) {
            toast.error("Please enter a valid email address");
            return;
        }
        if (!contactData?.subject) {
            toast.error("Please enter your subject");
            return;
        }
        if (!contactData?.message) {
            toast.error("Please enter your message");
            return;
        }
        contactUsApiCall()
    }

    const contactUsApiCall = () => {
        setProcessing(true);
        const requestBody: any = {
            name: contactData?.name,
            email: contactData?.email,
            subject: contactData?.subject,
            message: contactData?.message
        }
        contactUs(requestBody).then((res) => {
            console.log("contact us", res);
            // toast.success(res?.message)
            if (res?.validaterror === "1") {
                toast.error(res?.message)
                setProcessing(false)
                return;
            } else {
                setOpenSendMsgModal(true);
                setContactData(initialState)
                setProcessing(false)
            }
        }).catch((err) => {
            console.log("add space error", err);
        })
    }

    return (
        <>
            <Navbar transparent={false} />

            <div className="page-title">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <h2 className="ipt-title">Contact Us</h2>
                        </div>
                    </div>
                </div>
            </div>

            <section>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 col-md-7">
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label className='mb-2'>Name</label>
                                        <input
                                            type="text"
                                            className="form-control simple"
                                            value={contactData?.name}
                                            name='name'
                                            onChange={handleOnChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label className='mb-2'>Email</label>
                                        <input
                                            type="email"
                                            className="form-control simple"
                                            value={contactData?.email}
                                            name='email'
                                            onChange={handleOnChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <label className='mb-2'>Subject</label>
                                <input
                                    type="text"
                                    className="form-control simple"
                                    value={contactData?.subject}
                                    name='subject'
                                    onChange={handleOnChange}
                                />
                            </div>

                            <div className="form-group">
                                <label className='mb-2'>Message</label>
                                <textarea
                                    className="form-control simple"
                                    value={contactData?.message}
                                    name='message'
                                    onChange={handleOnChange}
                                >
                                </textarea>
                            </div>

                            <div className="form-group">
                                <button
                                    className="btn btn-primary px-5 rounded"
                                    type="submit"
                                    onClick={(e) => validation(e)}
                                    disabled={isProcessing}
                                    style={{ opacity: isProcessing ? 0.5 : 1 }}
                                >
                                    {isProcessing ? "Submitting..." : "Submit Request"}
                                </button>
                            </div>

                        </div>

                        <div className="col-lg-5 col-md-5">
                            <div className="contact-info">
                                <h2>Get In Touch</h2>

                                <div className="cn-info-detail">
                                    <div className="cn-info-icon">
                                        <i className="fa-solid fa-envelope-circle-check"></i>
                                    </div>
                                    <div className="cn-info-content">
                                        <h4 className="cn-info-title">Drop us an Email</h4>
                                        <span style={{ cursor: "pointer" }} onClick={() => window.open('mailto:support@commercialspc.com?subject=&body=')}>support@commercialspc.com</span>
                                    </div>
                                </div>
                                <div className="cn-info-detail">
                                    <div className="cn-info-icon">
                                        <i className="fa-solid fa-location-dot"></i>
                                    </div>
                                    <div className="cn-info-content">
                                        <h4 className="cn-info-title">Address</h4>
                                        <span style={{ cursor: "pointer" }} onClick={() => window.open('mailto:support@commercialspc.com?subject=&body=')}>CommercialSPC, LLC <br></br>945 North Point Drive <br></br>#115 <br></br>Alpharetta, GA 30022</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {
                    isOpenSendMsgModal &&
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                        <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                            <div className="modal-content" id="registermodal">
                                <span className="mod-close" onClick={() => setOpenSendMsgModal(!isOpenSendMsgModal)}>
                                    <span className="svg-icon text-primary svg-icon-2hx">
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                            <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                            <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                        </svg>
                                    </span>
                                </span>
                                <div className="modal-body">
                                    <h4 className="modal-header-title" style={{ fontSize: 25 }}>Sent Message</h4>
                                    <div className="d-flex align-items-center justify-content-center mb-3">
                                        <span>Your message
                                            has been sent successfully. Someone from our team will reply to you within 48
                                            hours</span>
                                    </div>
                                    <div className="form-group d-flex">
                                        <button type="button" className="btn btn-md btn-primary fw-medium full-width rounded-2" onClick={() => setOpenSendMsgModal(false)}>Ok</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </section>

            <Footer />
        </>
    )
}
